import { createContext, use } from "react";
import { defined } from "@entrilia/shared/utilities/typeHelper";
import type { DataImportFileContainer } from "../../../../../api/types/dataImportTypes";

export interface Props {
  onUpdateFileContainer: (fileContainer: DataImportFileContainer) => void;
  onDeleteFileContainer: (fileContainer: DataImportFileContainer) => void;
}

export const FileContainersListContext = createContext<Props | undefined>(undefined);

export const useFileContainersListContext = () =>
  defined(use(FileContainersListContext), "Attempt to use FileContainersListContext without provider");
